export default () => ({
  root: {
    marginTop: 15,
  },
  button: {
    textTransform: 'none !important',
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '10px !important',
  },
  title: {
    marginBottom: '24px !important',
  },
  error: {
    color: '#f44336',
    fontSize: '.75rem',
    padding: '0 25px',
  },
});
